/**
 * Source Han Sans CN Regular
 * Font Weight: 400
 */
export default {
    fontFamily: 'Source Han Sans',
    fontWeight: 400,
    fontStyle: 'normal',
    unitsPerEm: 1000,
    metrics: {
        ascender: 880,
        descender: -120,
        lineGap: 500,
    },
    glyphs: {
        ' ': 224,
        '\t': 224,
        '\n': 224,
        '\r': 224,
        '!': 323,
        '"': 475,
        '%': 921,
        '&': 680,
        '\'': 278,
        '(': 338,
        ')': 338,
        '*': 467,
        ',': 278,
        '-': 347,
        '.': 278,
        '/': 392,
        ':': 278,
        ';': 278,
        '?': 474,
        '@': 946,
        'B': 657,
        'C': 638,
        'D': 687,
        'E': 588,
        'F': 552,
        'G': 689,
        'H': 728,
        'I': 293,
        'J': 536,
        'K': 646,
        'L': 542,
        'M': 812,
        'N': 722,
        'P': 632,
        'R': 635,
        'S': 597,
        'T': 599,
        'V': 575,
        'W': 878,
        'X': 573,
        'Y': 531,
        'Z': 603,
        '[': 338,
        '\\': 392,
        ']': 338,
        '_': 559,
        'b': 618,
        'c': 509,
        'd': 620,
        'e': 554,
        'f': 325,
        'g': 563,
        'i': 275,
        'j': 275,
        'k': 552,
        'l': 285,
        'm': 926,
        'n': 611,
        'p': 620,
        'q': 620,
        'r': 388,
        's': 468,
        't': 377,
        'v': 521,
        'w': 802,
        'x': 498,
        'y': 521,
        'z': 474,
        '{': 338,
        '|': 269,
        '}': 338,
        '¡': 323,
        '¦': 269,
        '©': 832,
        'ª': 385,
        '«': 479,
        '®': 473,
        '°': 370,
        '²': 410,
        '³': 410,
        'µ': 628,
        '·': 561,
        '¹': 410,
        'º': 407,
        '»': 479,
        '¼': 872,
        '½': 903,
        '¾': 889,
        '¿': 474,
        'Æ': 918,
        'Ç': 638,
        'È': 588,
        'É': 588,
        'Ê': 588,
        'Ë': 588,
        'Ì': 293,
        'Í': 293,
        'Î': 293,
        'Ï': 293,
        'Ð': 712,
        'Ñ': 722,
        'Ý': 531,
        'Þ': 651,
        'ß': 642,
        'æ': 877,
        'ç': 509,
        'è': 554,
        'é': 554,
        'ê': 554,
        'ë': 554,
        'ì': 275,
        'í': 275,
        'î': 275,
        'ï': 275,
        'ð': 608,
        'ñ': 611,
        'ý': 521,
        'þ': 620,
        'ÿ': 521,
        'Đ': 712,
        'đ': 620,
        'Ē': 588,
        'ē': 554,
        'Ě': 588,
        'ě': 554,
        'Ĩ': 293,
        'ĩ': 275,
        'Ī': 293,
        'ī': 275,
        'Ń': 722,
        'ń': 611,
        'Ň': 722,
        'ň': 611,
        'Œ': 947,
        'œ': 937,
        'Ư': 736,
        'Ǐ': 293,
        'ǐ': 275,
        'Ǹ': 722,
        'ǹ': 611,
        'Β': 657,
        'Γ': 557,
        'Δ': 657,
        'Ε': 588,
        'Ζ': 603,
        'Η': 728,
        'Ι': 293,
        'Κ': 646,
        'Λ': 575,
        'Μ': 812,
        'Ν': 722,
        'Ξ': 595,
        'Π': 720,
        'Ρ': 632,
        'Σ': 601,
        'Τ': 599,
        'Υ': 531,
        'Φ': 803,
        'Χ': 573,
        'Ψ': 780,
        'Ω': 758,
        'α': 625,
        'β': 631,
        'γ': 540,
        'δ': 594,
        'ε': 501,
        'ζ': 473,
        'η': 604,
        'θ': 583,
        'ι': 292,
        'κ': 551,
        'λ': 552,
        'μ': 628,
        'ν': 528,
        'ξ': 481,
        'ο': 597,
        'π': 654,
        'ρ': 613,
        'σ': 610,
        'τ': 513,
        'υ': 569,
        'φ': 759,
        'χ': 537,
        'ψ': 769,
        'ω': 782,
        '‒': 536,
        '—': 894,
        '‚': 278,
        '„': 475,
        '•': 339,
        '′': 278,
        '″': 475,
        '‹': 302,
        '›': 302,
        '‼': 613,
        '⁇': 910,
        '⁈': 758,
        '⁉': 758,
        'ℓ': 457,
        '№': 997,
        '™': 711,
        '℮': 894,
        '✓': 683,
        '〪': 0,
        '〫': 0,
        '〬': 0,
        '〭': 0,
        '〮': 250,
        '〯': 250,
    },
    glyphsByWidth: {
        500: ' ｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟﾡﾢﾣﾤﾥﾦﾧﾨﾩﾪﾫﾬﾭﾮﾯﾰﾱﾲﾳﾴﾵﾶﾷﾸﾹﾺﾻﾼﾽﾾￂￃￄￅￆￇￊￋￌￍￎￏￒￓￔￕￖￗￚￛￜ￨￩￪￫￬￭￮',
        555: '#$+0123456789<=>^~¢£¤¥¬­ƒ₩€',
        564: 'aàáâãäåāăǎ',
        606: '`o¨¯´¸òóôõöøōŏơǒ',
        607: 'AhuÀÁÂÃÄÅùúûüĀĂũūŭưǍǔǖǘǚǜΑ',
        721: 'UÙÚÛÜŨŪŬǓǕǗǙǛ',
        742: 'OQÒÓÔÕÖØŌŎƠǑΘΟ',
        920: 'ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ',
    },
    defaultWidth: 1000,
    kerning: {
        '",': -128,
        '".': -128,
        '"A': -61,
        '"J': -106,
        '"S': -11,
        '"X': -11,
        '"c': -33,
        '"d': -33,
        '"e': -33,
        '"o': -33,
        '"q': -33,
        '"s': -22,
        '\',': -128,
        '\'.': -128,
        '\'A': -61,
        '\'J': -106,
        '\'S': -11,
        '\'X': -11,
        '\'c': -33,
        '\'d': -33,
        '\'e': -33,
        '\'o': -33,
        '\'q': -33,
        '\'s': -22,
        '(J': -22,
        '(j': 89,
        ',"': -107,
        ',\'': -107,
        ',*': -154,
        ',T': -110,
        ',U': -22,
        ',V': -73,
        ',W': -38,
        ',Y': -103,
        ',c': -13,
        ',d': -13,
        ',e': -13,
        ',j': 29,
        ',o': -13,
        ',q': -13,
        ',t': -51,
        ',v': -38,
        ',w': -25,
        ',y': -22,
        '-J': -22,
        '-S': -19,
        '-T': -53,
        '-V': -21,
        '-W': -11,
        '-X': -30,
        '-Y': -74,
        '-Z': -22,
        '-t': -29,
        '-v': -8,
        '-x': -15,
        '."': -107,
        '.\'': -107,
        '.*': -154,
        '.T': -110,
        '.U': -22,
        '.V': -73,
        '.W': -38,
        '.Y': -103,
        '.c': -13,
        '.d': -13,
        '.e': -13,
        '.j': 29,
        '.o': -13,
        '.q': -13,
        '.t': -51,
        '.v': -38,
        '.w': -25,
        '.y': -22,
        '/A': -45,
        '/C': -11,
        '/G': -11,
        '/J': -89,
        '/O': -11,
        '/Q': -11,
        '/a': -27,
        '/c': -35,
        '/d': -35,
        '/e': -35,
        '/g': -11,
        '/i': 29,
        '/j': 29,
        '/o': -35,
        '/q': -35,
        '/t': 10,
        '/u': -22,
        ':*': -55,
        ':Y': -29,
        ':j': 4,
        ';*': -55,
        ';Y': -29,
        ';j': 4,
        'A"': -61,
        'A\'': -61,
        'A*': -105,
        'A?': -29,
        'AA': -7,
        'AC': -11,
        'AG': -11,
        'AO': -11,
        'AQ': -11,
        'AT': -61,
        'AU': -17,
        'AV': -15,
        'AX': 4,
        'AY': -15,
        'AZ': -8,
        'A\\': -45,
        'Aa': 26,
        'Af': -11,
        'As': 26,
        'At': -15,
        'Au': -7,
        'Av': -8,
        'Aw': -4,
        'Ax': -4,
        'Ay': -8,
        'B*': -34,
        'BJ': -18,
        'BS': -15,
        'BT': -27,
        'BV': -6,
        'BW': -4,
        'BX': -4,
        'BY': -15,
        'BZ': -4,
        'Bt': -11,
        'Bv': -15,
        'Bw': -11,
        'Bx': -11,
        'By': -15,
        'C-': -29,
        'CC': -32,
        'CG': -32,
        'CJ': -11,
        'CO': -32,
        'CQ': -32,
        'CS': -27,
        'CT': -20,
        'CU': -15,
        'CV': -4,
        'CW': -4,
        'CX': -4,
        'CY': -8,
        'CZ': -11,
        'Cg': -22,
        'Ct': -30,
        'Cu': -11,
        'Cv': -15,
        'Cw': -11,
        'Cy': -15,
        'D*': -38,
        'D/': -20,
        'DA': -11,
        'DJ': -44,
        'DT': -27,
        'DV': -11,
        'DW': -7,
        'DX': -19,
        'DY': -22,
        'DZ': -22,
        'Dx': -15,
        'Dz': -8,
        'Ec': -11,
        'Ed': -11,
        'Ee': -11,
        'Eo': -11,
        'Eq': -11,
        'Et': -27,
        'Ev': -11,
        'Ex': -34,
        'Ey': -11,
        'F,': -81,
        'F.': -81,
        'F/': -78,
        'FA': -42,
        'FC': -11,
        'FG': -11,
        'FJ': -155,
        'FO': -11,
        'FQ': -11,
        'FS': -22,
        'FV': 4,
        'FW': 4,
        'FX': -27,
        'FZ': -34,
        'Fa': -38,
        'Fc': -15,
        'Fd': -15,
        'Fe': -15,
        'Fg': -27,
        'Fm': -22,
        'Fn': -22,
        'Fo': -15,
        'Fp': -22,
        'Fq': -15,
        'Fr': -22,
        'Fs': -22,
        'Ft': -11,
        'Fu': -18,
        'Fv': -22,
        'Fw': -18,
        'Fx': -29,
        'Fy': -18,
        'Fz': -33,
        'G*': -31,
        'GA': -4,
        'GT': -22,
        'GV': -15,
        'GW': -4,
        'J,': -27,
        'J.': -27,
        'JJ': -45,
        'K"': -23,
        'K\'': -23,
        'K*': -45,
        'K-': -33,
        'K?': -8,
        'KA': -11,
        'KC': -22,
        'KG': -22,
        'KO': -22,
        'KQ': -22,
        'KS': -10,
        'KT': -19,
        'KU': -15,
        'KV': -14,
        'KW': -11,
        'KY': -18,
        'Kc': -8,
        'Kd': -8,
        'Ke': -8,
        'Kj': -11,
        'Ko': -8,
        'Kq': -8,
        'Kt': -37,
        'Ku': -16,
        'Kv': -22,
        'Kw': -18,
        'Kx': -18,
        'Ky': -22,
        'Kz': -15,
        'L"': -99,
        'L\'': -99,
        'L*': -170,
        'L-': -60,
        'L?': -36,
        'LA': 3,
        'LC': -29,
        'LG': -29,
        'LO': -29,
        'LQ': -29,
        'LS': -25,
        'LT': -134,
        'LU': -32,
        'LV': -85,
        'LW': -63,
        'LY': -85,
        'L\\': -89,
        'Lc': -13,
        'Ld': -13,
        'Le': -13,
        'Lf': -15,
        'Lg': -4,
        'Lo': -13,
        'Lq': -13,
        'Lt': -22,
        'Lu': -11,
        'Lv': -40,
        'Lw': -38,
        'Ly': -40,
        'O*': -38,
        'O/': -20,
        'OA': -11,
        'OJ': -44,
        'OT': -27,
        'OV': -11,
        'OW': -7,
        'OX': -19,
        'OY': -22,
        'OZ': -22,
        'Ox': -15,
        'Oz': -8,
        'P,': -125,
        'P-': -37,
        'P.': -125,
        'P/': -85,
        'PA': -56,
        'PJ': -164,
        'PS': -11,
        'PT': -27,
        'PX': -27,
        'PY': -11,
        'PZ': -87,
        'Pa': -48,
        'Pc': -27,
        'Pd': -27,
        'Pe': -27,
        'Pg': -34,
        'Po': -27,
        'Pq': -27,
        'Ps': -11,
        'Px': -15,
        'Pz': -22,
        'Q*': -38,
        'Q/': -20,
        'QA': -11,
        'QJ': -44,
        'QT': -27,
        'QV': -11,
        'QW': -7,
        'QX': -19,
        'QY': -22,
        'QZ': -22,
        'Qx': -15,
        'Qz': -8,
        'R*': -11,
        'R-': -35,
        'RA': -4,
        'RJ': -20,
        'RS': -15,
        'RT': -15,
        'RV': 6,
        'RW': 7,
        'RX': -4,
        'RZ': -11,
        'Ra': -4,
        'Rc': -11,
        'Rd': -11,
        'Re': -11,
        'Rg': -4,
        'Ro': -11,
        'Rq': -11,
        'Rx': -8,
        'Rz': -8,
        'S*': -18,
        'S-': 15,
        'SJ': -15,
        'SS': -15,
        'ST': -22,
        'SY': -15,
        'St': -27,
        'T,': -119,
        'T-': -81,
        'T.': -119,
        'T/': -100,
        'T:': -22,
        'T;': -22,
        'TA': -45,
        'TC': -27,
        'TG': -27,
        'TJ': -141,
        'TO': -27,
        'TQ': -27,
        'TS': -44,
        'TX': -22,
        'TY': -15,
        'TZ': -60,
        'Ta': -81,
        'Tc': -74,
        'Td': -74,
        'Te': -74,
        'Tf': -20,
        'Tg': -81,
        'Tm': -52,
        'Tn': -52,
        'To': -74,
        'Tp': -52,
        'Tq': -74,
        'Tr': -52,
        'Ts': -66,
        'Tt': -20,
        'Tu': -52,
        'Tv': -37,
        'Tw': -38,
        'Tx': -44,
        'Ty': -37,
        'Tz': -84,
        'U,': -18,
        'U.': -18,
        'U/': -35,
        'UA': -18,
        'UJ': -53,
        'US': -11,
        'UV': -4,
        'UX': -11,
        'UY': -15,
        'Ua': -4,
        'Ug': -11,
        'Us': -4,
        'Ux': -8,
        'V,': -73,
        'V-': -21,
        'V.': -73,
        'V/': -52,
        'VA': -15,
        'VC': -11,
        'VG': -11,
        'VJ': -81,
        'VO': -11,
        'VQ': -11,
        'VS': -11,
        'VU': -11,
        'VV': 11,
        'VZ': -21,
        'Va': -25,
        'Vc': -17,
        'Vd': -17,
        'Ve': -17,
        'Vg': -24,
        'Vm': -22,
        'Vn': -22,
        'Vo': -17,
        'Vp': -22,
        'Vq': -17,
        'Vr': -22,
        'Vs': -14,
        'Vu': -34,
        'Vv': -10,
        'Vw': -10,
        'Vx': -17,
        'Vy': -10,
        'Vz': -28,
        'W,': -38,
        'W-': -11,
        'W.': -38,
        'W/': -33,
        'WC': -7,
        'WG': -7,
        'WJ': -73,
        'WO': -7,
        'WQ': -7,
        'WS': -7,
        'WZ': -7,
        'Wa': -18,
        'Wg': -14,
        'Wz': -11,
        'X"': -11,
        'X\'': -11,
        'X*': -11,
        'X-': -30,
        'XA': 3,
        'XC': -19,
        'XG': -19,
        'XO': -19,
        'XQ': -19,
        'XS': -15,
        'XT': -22,
        'XU': -11,
        'Xa': -11,
        'Xc': -8,
        'Xd': -8,
        'Xe': -8,
        'Xf': -18,
        'Xo': -8,
        'Xq': -8,
        'Xt': -18,
        'Xu': -11,
        'Xv': -18,
        'Xw': -15,
        'Xx': -11,
        'Xy': -18,
        'Xz': -15,
        'Y,': -101,
        'Y-': -74,
        'Y.': -101,
        'Y/': -75,
        'Y:': -28,
        'Y;': -28,
        'Y?': -8,
        'YA': -15,
        'YC': -15,
        'YG': -15,
        'YJ': -112,
        'YO': -15,
        'YQ': -15,
        'YS': -18,
        'YT': -15,
        'YU': -11,
        'YZ': -29,
        'Ya': -75,
        'Yc': -46,
        'Yd': -46,
        'Ye': -46,
        'Yg': -67,
        'Ym': -45,
        'Yn': -45,
        'Yo': -46,
        'Yp': -45,
        'Yq': -46,
        'Yr': -45,
        'Ys': -46,
        'Yt': -31,
        'Yu': -38,
        'Yv': -15,
        'Yw': -27,
        'Yx': -38,
        'Yy': -15,
        'Yz': -53,
        'Z-': -38,
        'ZA': -7,
        'ZC': -22,
        'ZG': -22,
        'ZJ': -37,
        'ZO': -22,
        'ZQ': -22,
        'ZS': -34,
        'ZU': -11,
        'ZV': -7,
        'ZW': -7,
        'ZY': -15,
        'ZZ': -18,
        'Za': -18,
        'Zc': -24,
        'Zd': -24,
        'Ze': -24,
        'Zf': -22,
        'Zg': -16,
        'Zo': -24,
        'Zq': -24,
        'Zt': -15,
        'Zu': -26,
        'Zv': -18,
        'Zw': -18,
        'Zx': -27,
        'Zy': -18,
        '[J': -22,
        '[j': 89,
        '\\T': -96,
        '\\U': -33,
        '\\V': -59,
        '\\W': -33,
        '\\Y': -81,
        '\\g': 37,
        '\\j': 81,
        '\\v': -22,
        '\\w': -11,
        '\\y': 14,
        'a*': -60,
        'a?': -14,
        'aT': -27,
        'aV': -18,
        'aW': -4,
        'aY': -27,
        'at': -15,
        'b"': -33,
        'b\'': -33,
        'b*': -29,
        'b,': -11,
        'b-': 7,
        'b.': -11,
        'b?': -14,
        'bT': -64,
        'bV': -21,
        'bX': -4,
        'bY': -52,
        'b\\': -29,
        'ba': -16,
        'bt': -19,
        'bv': -4,
        'bw': -4,
        'bx': -19,
        'by': -4,
        'bz': -6,
        'c-': -22,
        'cT': -22,
        'cV': -15,
        'cY': -27,
        'ca': -11,
        'cc': -24,
        'cd': -24,
        'ce': -24,
        'cg': -11,
        'co': -24,
        'cq': -24,
        'ct': -11,
        'cv': 7,
        'cw': 7,
        'cx': 9,
        'cy': 7,
        'e*': -38,
        'e-': 11,
        'e?': -8,
        'eJ': -22,
        'eS': -22,
        'eT': -27,
        'eV': -18,
        'eW': -11,
        'eY': -29,
        'e\\': -22,
        'ea': -16,
        'eg': -11,
        'et': -11,
        'ev': 5,
        'ew': 5,
        'ex': -8,
        'ey': 5,
        'f!': 16,
        'f"': 45,
        'f\'': 45,
        'f)': 55,
        'f,': -56,
        'f-': -15,
        'f.': -56,
        'f/': -16,
        'f?': 29,
        'fT': 52,
        'fV': 74,
        'fW': 52,
        'fX': 37,
        'fY': 66,
        'f\\': 70,
        'f]': 55,
        'fa': -22,
        'fc': -11,
        'fd': -11,
        'fe': -11,
        'fg': -16,
        'fj': -11,
        'fo': -11,
        'fq': -11,
        'fs': -4,
        'fv': 14,
        'fx': -4,
        'fz': -15,
        'f}': 55,
        'g)': 16,
        'g*': -37,
        'g/': 53,
        'g?': -40,
        'gT': -29,
        'gY': -15,
        'g]': 16,
        'ga': -18,
        'gc': -15,
        'gd': -15,
        'ge': -15,
        'gj': 41,
        'go': -15,
        'gq': -15,
        'gv': -4,
        'gw': -4,
        'gy': 17,
        'gz': -15,
        'g}': 16,
        'h*': -38,
        'h?': -8,
        'hT': -27,
        'hV': -11,
        'hY': -18,
        'k*': -24,
        'k,': 14,
        'k-': -49,
        'k.': 14,
        'k:': 14,
        'k;': 14,
        'k?': -14,
        'kT': -39,
        'kY': -13,
        'ka': -11,
        'kc': -20,
        'kd': -20,
        'ke': -20,
        'kg': -11,
        'kj': -11,
        'ko': -20,
        'kq': -20,
        'kt': -23,
        'ku': -15,
        'kx': -8,
        'kz': -8,
        'lj': 9,
        'm*': -38,
        'm?': -8,
        'mT': -27,
        'mV': -11,
        'mY': -18,
        'n*': -38,
        'n?': -8,
        'nT': -27,
        'nV': -11,
        'nY': -18,
        'o"': -33,
        'o\'': -33,
        'o*': -29,
        'o,': -11,
        'o-': 7,
        'o.': -11,
        'o?': -14,
        'oT': -64,
        'oV': -21,
        'oX': -4,
        'oY': -52,
        'o\\': -29,
        'oa': -16,
        'ot': -19,
        'ov': -4,
        'ow': -4,
        'ox': -19,
        'oy': -4,
        'oz': -6,
        'p"': -33,
        'p\'': -33,
        'p*': -29,
        'p,': -11,
        'p-': 7,
        'p.': -11,
        'p?': -14,
        'pT': -64,
        'pV': -21,
        'pX': -4,
        'pY': -52,
        'p\\': -29,
        'pa': -16,
        'pt': -19,
        'pv': -4,
        'pw': -4,
        'px': -19,
        'py': -4,
        'pz': -6,
        'q*': -27,
        'qT': -22,
        'qV': -15,
        'qY': -34,
        'r,': -63,
        'r-': -27,
        'r.': -63,
        'r/': -38,
        'r:': 29,
        'r;': 29,
        'rA': -15,
        'rJ': -61,
        'rZ': -11,
        'r\\': 14,
        'ra': -27,
        'rc': -11,
        'rd': -11,
        're': -11,
        'rg': -11,
        'ro': -11,
        'rq': -11,
        'rs': -4,
        'rv': 29,
        'rw': 21,
        'ry': 29,
        'rz': -4,
        's*': -55,
        's-': 11,
        's?': -12,
        'sT': -27,
        'sV': -11,
        'sY': -22,
        'st': -22,
        't,': 7,
        't-': -29,
        't.': 7,
        't/': 11,
        't:': 16,
        't;': 16,
        't?': -29,
        'tT': -15,
        'tY': -4,
        'ta': -24,
        'tc': -15,
        'td': -15,
        'te': -15,
        'tg': -11,
        'to': -15,
        'tq': -15,
        'ts': -11,
        'tt': -22,
        'tx': -18,
        'u*': -27,
        'uT': -22,
        'uV': -15,
        'uY': -34,
        'v*': -13,
        'v,': -38,
        'v-': -8,
        'v.': -38,
        'v/': -22,
        'vA': -13,
        'vJ': -45,
        'vT': -22,
        'vV': -10,
        'vY': -15,
        'vZ': -11,
        'va': -22,
        'vc': -4,
        'vd': -4,
        've': -4,
        'vj': -11,
        'vo': -4,
        'vq': -4,
        'vz': -27,
        'w*': -13,
        'w,': -45,
        'w.': -45,
        'w/': -8,
        'wA': -4,
        'wJ': -34,
        'wT': -27,
        'wV': -10,
        'wX': -15,
        'wY': -27,
        'wa': -11,
        'wc': -4,
        'wd': -4,
        'we': -4,
        'wj': -11,
        'wo': -4,
        'wq': -4,
        'wz': -19,
        'x!': -15,
        'x*': -25,
        'x,': 8,
        'x-': -15,
        'x.': -8,
        'x;': 8,
        'xC': -11,
        'xG': -11,
        'xO': -11,
        'xQ': -11,
        'xS': -4,
        'xT': -37,
        'xV': -17,
        'xX': -11,
        'xY': -38,
        'xa': -11,
        'xc': -19,
        'xd': -19,
        'xe': -19,
        'xo': -19,
        'xq': -19,
        'xt': -27,
        'y,': -38,
        'y.': -38,
        'y/': -16,
        'yJ': -45,
        'yT': -22,
        'yV': -4,
        'yX': -4,
        'yY': -8,
        'ya': -22,
        'yc': -4,
        'yd': -4,
        'ye': -4,
        'yj': -11,
        'yo': -4,
        'yq': -4,
        'yx': -15,
        'yz': -27,
        'z-': -18,
        'zT': -29,
        'zY': -33,
        'za': -26,
        'zc': -11,
        'zd': -11,
        'ze': -11,
        'zg': -7,
        'zo': -11,
        'zq': -11,
        'zu': -11,
        'zv': -4,
        'zy': -4,
        '{J': -22,
        '{j': 89,
    },
};
